/**
 * This function returns a map entry or v that is added to the map.
 *
 * @param map
 * @param k
 * @param v
 */
export function getOrCreate(map, k, v) {
    const value = map.get(k);
    if (value === undefined) {
        const newValue = typeof v === 'function' ? v() : v;
        map.set(k, newValue);
        return newValue;
    }
    else {
        return value;
    }
}
export function isLastKey(map, k) {
    const keys = [...map.keys()];
    return k === keys[keys.length - 1];
}
export function isLastValue(map, v) {
    const values = [...map.values()];
    return v === values[values.length - 1];
}
export function isLastEntry(map, e) {
    const entries = [...map.entries()];
    return e[0] === entries[entries.length - 1][0] && e[1] === entries[entries.length - 1][1];
}
//# sourceMappingURL=MapUtils.js.map